import { useContext } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { useTranslation } from 'react-i18next'

import { Participant } from 'types/Participants'
import { setBlockedFlag } from 'api/Participant/UpdateParticipant/Action'
import { useAlert } from 'components/Shared/Alert'
import { ParticpantsContext } from 'containers/Participants'
import { updateParticipant } from 'containers/Participants/Redux/Actions/ParticipantGrid'
import {
  dialogActionButton,
  dialogCancelButtonMob,
  blockDialogCancelBtnDesk,
  dialogIcon,
  dialogContent,
  dialog,
} from 'components/Participants/ParticipantActions/Block/Styles'

type Props = {
  isOpen: boolean
  participant: Participant
  setModalVisibility: (isOpen: boolean) => void
  getParticipant?: () => void | null
}

const UnBlockDialog = ({
  isOpen,
  setModalVisibility,
  participant,
  getParticipant,
}: Props) => {
  const { t } = useTranslation()
  const { showAlert } = useAlert()

  const {
    functions: { dispatch },
  } = useContext(ParticpantsContext)

  const handleClose = () => {
    setModalVisibility(false)
  }

  const handleError = () => {
    showAlert({ type: 'error', title: t('alert.error.400') })
  }

  const handleSuccess = () => {
    showAlert({
      type: 'success',
      title: t('participant.blockUnblock.alert.unblock'),
    })
    if (getParticipant) getParticipant()
  }

  const handleClick = async () => {
    const response = await setBlockedFlag(participant.id, false)

    if (response.status && response.status !== 200) {
      handleError()
      return
    }

    handleSuccess()
    setModalVisibility(false)
    dispatch(
      updateParticipant({
        ...participant,
        blocked: false,
      }),
    )
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      PaperProps={{
        sx: dialog,
      }}
    >
      <DialogContent sx={dialogContent}>
        <LockOpenIcon style={dialogIcon} color="primary" />
        <Typography
          variant="h5"
          component="h5"
          marginTop={2}
          textAlign="center"
        >
          {t('participant.actions.unblock.dialogTitle')}
        </Typography>
        <Typography variant="body1" marginTop={2} textAlign="center">
          {t('participant.actions.unblock.dialogDescription')}
        </Typography>
      </DialogContent>
      <DialogActions sx={dialogActionButton}>
        <Button
          sx={dialogCancelButtonMob}
          variant="outlined"
          onClick={handleClose}
        >
          {t('common.cancel')}
        </Button>
        <Button
          sx={blockDialogCancelBtnDesk}
          variant="text"
          onClick={handleClose}
        >
          {t('common.cancel')}
        </Button>
        <Button variant="contained" onClick={handleClick}>
          {t('common.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnBlockDialog
